import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DepartmentListComponent} from './department-list/department-list.component';


export const departmentRoutes: Routes = [
  {
    path: 'department',
    data: {
      'expectedRoles': ['Admin', 'IT', 'Accountant', 'Accountant Admin', 'UIH','Finance Admin', 'IT Admin']
    },
    children: [
      {
        path: 'list',
        component: DepartmentListComponent,
        data: {
          'expectedRoles': ['Admin','Finance Admin', 'Accountant', 'Accountant Admin', 'IT']
        },
      },
      {
        path: 'manage',
        component: DepartmentListComponent,
        data: {
          'expectedRoles': ['Admin','Finance Admin', 'Accountant', 'Accountant Admin', 'IT']
        },
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(departmentRoutes)],
  exports: [RouterModule]
})
export class DepartmentRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/department/department-routing.module.ts